var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.clients.length > 0)?_c('Dropdown',{attrs:{"options":_vm.clients,"disabled":_vm.disabled || _vm.isClientsEmpty,"textValue":_vm.displayValue},on:{"select":_vm.selectClient}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }